import React from 'react';
import { MessageSquareWarning } from 'lucide-react';
import { accountHook } from '../lib/domHooks';

// Yöneticinin reddedilen talebe yazdığı sebep. Kaynak `transactions.reject_reason`
// kolonudur — `note` iç kayıttır ve oyuncuya hiç çizilmez. Sebep yazılmamışsa
// satır çizilmez; aynı metin üyenin Mesajlarım kutusuna da düşer.
const RejectReasonNote = ({ transaction }) => {
  const reason = String(transaction?.reject_reason || '').trim();
  if (transaction?.status !== 'reddedildi' || !reason) return null;
  return (
    <div className="account-reject-note mt-3 flex gap-2 p-3 text-xs" {...accountHook('reject-reason')}>
      <MessageSquareWarning size={15} className="account-reject-note-icon mt-px shrink-0" aria-hidden="true" />
      <div className="min-w-0">
        <span className="account-reject-note-label">Red sebebi: </span>
        <span className="whitespace-pre-wrap break-words">{reason}</span>
      </div>
    </div>
  );
};

export default RejectReasonNote;
